import React from "react";
import "../css/Memberships.css";
import line from "../images/line.png";

import memberships from "../utils/memberships";
import Membership from "./cards/Membership";

import Image from "react-image-webp";
import image from "../images/award-background.png"
import imageWebp from "../images/award-background.webp"

import decoration from "../images/decorations/counseling_decoration_2.png"

const Memberships = () => {

    const membershipsList = memberships.map((training) => (
        <Membership
            key={training.id}
            image={training.image}
            icon={training.icon}
            title={training.title}
            price={training.price}
            price_before={training.price_before}
            items={training.items}
            urls={training.urls}
        />
    ));

    return (
        <section className="Memberships" id="entrenamientos">
            <div className="memberships-container container padding">
                <Image webp={imageWebp} src={image} alt="Memberships Background" className="memberships-image" />
                <img src={decoration} alt="Membership Decoration" className="membership-decoration"/>
                <div className="memberships-header">
                    <h1>
                        ESCUELA
                        <br />
                        <span>ZBRUSH</span>
                        <img
                            className="convert-underline"
                            src={line}
                            alt="underline"
                        />
                    </h1>
                </div>
                <div className="memberships-content">
                    {membershipsList}
                </div>
            </div>
        </section>
    );
};

export default Memberships;
